import React from 'react';
import { Card, Tabs, TabsProps } from 'antd';
import { SettingsWrapper } from './styled';
import Users from './components/Users';

const Settings = () => {
  const onChange = (key: string) => {
    console.log(key);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Users',
      children: <Users />,
    },
    // {
    //     key: '2',
    //     label: 'Preferences',
    //     children: 'Content of Tab Pane 3',
    // },
  ];
  return (
    <SettingsWrapper>
      <Card>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
      </Card>
    </SettingsWrapper>
  );
};

export default Settings;
